import { userActionBadgeMessages } from 'src/features/userAction/utils/messages';
import { BadgeOption } from 'src/registry/types/badges';
import { Translation } from 'src/types';

export enum UserActionType {
    ACTIVE_STAY_ENDED = 'active_stay_ended',
    CLOUD_USER_ACTIVATED = 'cloud_user_activated',
    CLOUD_USER_DEACTIVATED = 'cloud_user_deactivated',
    CLOUD_USER_UPDATED = 'cloud_user_updated',
    CLOUD_USER_DELETED = 'cloud_user_deleted',
    EMERGENCY_CLOSE_GATEWAY = 'emergency_close_gateway',
    EMERGENCY_OPEN_GATEWAY = 'emergency_open_gateway',
    ENTITY_CREATED = 'entity_created',
    ENTITY_DELETED = 'entity_deleted',
    ENTITY_UPDATED = 'entity_updated',
    GATEWAY_OPENED = 'gateway_opened',
    LOGIN = 'login',
    MEMBERSHIP_ALLOWED_TIME_CREATED = 'membership_allowed_time_created',
    MEMBERSHIP_ALLOWED_TIME_DELETED = 'membership_allowed_time_deleted',
    MEMBERSHIP_ALLOWED_TIME_UPDATED = 'membership_allowed_time_updated',
    MEMBERSHIP_CLOUD_USER_CREATED = 'membership_cloud_user_created',
    MEMBERSHIP_CLOUD_USER_DELETED = 'membership_cloud_user_deleted',
    MEMBERSHIP_CLOUD_USER_UPDATED = 'membership_cloud_user_updated',
    MEMBERSHIP_CREATED = 'membership_created',
    MEMBERSHIP_UPDATED = 'membership_updated',
    MEMBERSHIP_DELETED = 'membership_deleted',
    MEMBERSHIP_IDENTIFIER_CREATED = 'membership_identifier_created',
    MEMBERSHIP_IDENTIFIER_DELETED = 'membership_identifier_deleted',
    MEMBERSHIP_IDENTIFIER_UPDATED = 'membership_identifier_updated',
    MEMBERSHIP_IDENTIFIER_ARCHIVED = 'membership_identifier_archived',
    MEMBERSHIP_TYPE_ACTIVATED = 'membership_type_activated',
    MEMBERSHIP_TYPE_DEACTIVATED = 'membership_type_deactivated',
    MEMBERSHIP_TYPE_ALLOWED_TIME_CREATED = 'membership_type_allowed_time_created',
    MEMBERSHIP_TYPE_ALLOWED_TIME_DELETED = 'membership_type_allowed_time_deleted',
    MEMBERSHIP_TYPE_ALLOWED_TIME_UPDATED = 'membership_type_allowed_time_updated',
    MEMBERSHIP_TYPE_ZONE_RULE_CREATED = 'membership_type_zone_rule_created',
    MEMBERSHIP_TYPE_ZONE_RULE_DELETED = 'membership_type_zone_rule_deleted',
    MEMBERSHIP_TYPE_ZONE_RULE_UPDATED = 'membership_type_zone_rule_updated',
    MEMBERSHIP_ZONE_RULE_CREATED = 'membership_zone_rule_created',
    MEMBERSHIP_ZONE_RULE_DELETED = 'membership_zone_rule_deleted',
    MEMBERSHIP_ZONE_RULE_UPDATED = 'membership_zone_rule_updated',
    USER_ACTIVATED = 'user_activated',
    USER_DEACTIVATED = 'user_deactivated',
    USER_CREATED = 'user_created',
    USER_DELETED = 'user_deleted',
    USER_UPDATED = 'user_updated',
    VISITOR_ADDED_TO_PARKING = 'visitor_added_to_parking',
}

export const userActionBadgeOptions: Record<UserActionType, BadgeOption> = {
    [UserActionType.LOGIN]: {
        label: userActionBadgeMessages.login,
        theme: 'green',
    },
    [UserActionType.ACTIVE_STAY_ENDED]: {
        label: userActionBadgeMessages.activeStayEnded,
        theme: 'red',
    },
    [UserActionType.GATEWAY_OPENED]: {
        label: userActionBadgeMessages.gatewayOpened,
        theme: 'blue',
    },
    [UserActionType.EMERGENCY_OPEN_GATEWAY]: {
        label: userActionBadgeMessages.emergencyGatewayOpened,
        theme: 'orange',
    },
    [UserActionType.EMERGENCY_CLOSE_GATEWAY]: {
        label: userActionBadgeMessages.emergencyGatewayClosed,
        theme: 'orange',
    },
    [UserActionType.MEMBERSHIP_CREATED]: {
        label: userActionBadgeMessages.membershipCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_UPDATED]: {
        label: userActionBadgeMessages.membershipUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_DELETED]: {
        label: userActionBadgeMessages.membershipDeleted,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_IDENTIFIER_CREATED]: {
        label: userActionBadgeMessages.membershipIdentifierCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_IDENTIFIER_UPDATED]: {
        label: userActionBadgeMessages.membershipIdentifierUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_IDENTIFIER_DELETED]: {
        label: userActionBadgeMessages.membershipIdentifierDeleted,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_ZONE_RULE_CREATED]: {
        label: userActionBadgeMessages.membershipZoneRuleCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_ZONE_RULE_UPDATED]: {
        label: userActionBadgeMessages.membershipZoneRuleUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_ZONE_RULE_DELETED]: {
        label: userActionBadgeMessages.membershipZoneRuleDeleted,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_ALLOWED_TIME_CREATED]: {
        label: userActionBadgeMessages.membershipAllowedTimeCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_ALLOWED_TIME_UPDATED]: {
        label: userActionBadgeMessages.membershipAllowedTimeUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_ALLOWED_TIME_DELETED]: {
        label: userActionBadgeMessages.membershipAllowedTimeDeleted,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_CLOUD_USER_CREATED]: {
        label: userActionBadgeMessages.membershipCloudUserCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_CLOUD_USER_UPDATED]: {
        label: userActionBadgeMessages.membershipCloudUserUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_CLOUD_USER_DELETED]: {
        label: userActionBadgeMessages.membershipCloudUserDeleted,
        theme: 'red',
    },
    [UserActionType.USER_ACTIVATED]: {
        label: userActionBadgeMessages.userActivated,
        theme: 'blue',
    },
    [UserActionType.USER_DEACTIVATED]: {
        label: userActionBadgeMessages.userDeactivated,
        theme: 'red',
    },
    [UserActionType.USER_CREATED]: {
        label: userActionBadgeMessages.userCreated,
        theme: 'green',
    },
    [UserActionType.USER_UPDATED]: {
        label: userActionBadgeMessages.userUpdated,
        theme: 'blue',
    },
    [UserActionType.USER_DELETED]: {
        label: userActionBadgeMessages.userDeleted,
        theme: 'red',
    },
    [UserActionType.ENTITY_CREATED]: {
        label: userActionBadgeMessages.entityCreated,
        theme: 'green',
    },
    [UserActionType.ENTITY_UPDATED]: {
        label: userActionBadgeMessages.entityUpdated,
        theme: 'blue',
    },
    [UserActionType.ENTITY_DELETED]: {
        label: userActionBadgeMessages.entityDeleted,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_IDENTIFIER_ARCHIVED]: {
        label: userActionBadgeMessages.membershipIdentifierArchived,
        theme: 'gray',
    },
    [UserActionType.MEMBERSHIP_TYPE_ACTIVATED]: {
        label: userActionBadgeMessages.membershipTypeActivated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_TYPE_DEACTIVATED]: {
        label: userActionBadgeMessages.membershipTypeDeactivated,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_TYPE_ALLOWED_TIME_CREATED]: {
        label: userActionBadgeMessages.membershipTypeAllowedTimeCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_TYPE_ALLOWED_TIME_UPDATED]: {
        label: userActionBadgeMessages.membershipTypeAllowedTimeUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_TYPE_ALLOWED_TIME_DELETED]: {
        label: userActionBadgeMessages.membershipTypeAllowedTimeDeleted,
        theme: 'red',
    },
    [UserActionType.MEMBERSHIP_TYPE_ZONE_RULE_CREATED]: {
        label: userActionBadgeMessages.membershipTypeZoneRuleCreated,
        theme: 'green',
    },
    [UserActionType.MEMBERSHIP_TYPE_ZONE_RULE_UPDATED]: {
        label: userActionBadgeMessages.membershipTypeZoneRuleUpdated,
        theme: 'blue',
    },
    [UserActionType.MEMBERSHIP_TYPE_ZONE_RULE_DELETED]: {
        label: userActionBadgeMessages.membershipTypeZoneRuleDeleted,
        theme: 'red',
    },
    [UserActionType.CLOUD_USER_ACTIVATED]: {
        label: userActionBadgeMessages.cloudUserActivated,
        theme: 'blue',
    },
    [UserActionType.CLOUD_USER_DEACTIVATED]: {
        label: userActionBadgeMessages.cloudUserDeactivated,
        theme: 'red',
    },
    [UserActionType.CLOUD_USER_UPDATED]: {
        label: userActionBadgeMessages.cloudUserUpdated,
        theme: 'blue',
    },
    [UserActionType.CLOUD_USER_DELETED]: {
        label: userActionBadgeMessages.cloudUserDeleted,
        theme: 'red',
    },
    [UserActionType.VISITOR_ADDED_TO_PARKING]: {
        label: userActionBadgeMessages.visitorAddedToParking,
        theme: 'blue',
    },
};

export type Login = {
    username: string;
    name: string;
};

export type ActiveStayEnded = {
    visitor: {
        id: string;
        main_identifier?: {
            type: string;
            value: string;
        };
    };
    active_stay_ref: string;
    past_stay_id: string;
    exit_gateway_id?: string;
    identifiers?: {
        type: string;
        value: string;
    };
};

export type GatewayOpened = {
    gateway: {
        id: string;
        names: Translation[];
    };
    reason?: string;
};

export type EmergencyOpenGateway = GatewayOpened;

export type EmergencyCloseGateway = GatewayOpened;

export type UpdateEvent<TResults extends object> = TResults & {
    changes: Record<
        string,
        {
            from_value: string;
            to_value: string;
        }
    >;
};

export type MembershipCreated = {
    id: string;
    ref: string;
    name: string;
};

export type MembershipUpdated = UpdateEvent<MembershipCreated>;

export type MembershipDeleted = MembershipCreated;

export type MembershipIdentifierCreated = {
    id: string;
    membership: {
        id: string;
        ref: string;
        name: string;
    };
    identifier: {
        type: string;
        value: string;
    };
    owner?: {
        id: string;
        value: string;
    };
};

export type MembershipIdentifierUpdated = UpdateEvent<MembershipIdentifierCreated>;

export type MembershipIdentifierDeleted = MembershipIdentifierCreated;

export type MembershipIdentifierArchived = MembershipIdentifierCreated;

export type MembershipZoneRuleCreated = {
    id: string;
    membership: {
        id: string;
        ref: string;
        name: string;
    };
    zone: {
        id: string;
        names: Translation[];
    };
};

export type MembershipZoneRuleUpdated = UpdateEvent<MembershipZoneRuleCreated>;

export type MembershipZoneRuleDeleted = MembershipZoneRuleCreated;

export type MembershipAllowedTimeCreated = {
    id: string;
    membership: {
        id: string;
        ref: string;
        name: string;
    };
    from_time: string;
    to_time: string;
};
export type MembershipAllowedTimeUpdated = UpdateEvent<Omit<MembershipAllowedTimeCreated, 'from_time' | 'to_time'>>;

export type MembershipAllowedTimeDeleted = Omit<MembershipAllowedTimeCreated, 'from_time' | 'to_time'>;

export type MembershipCloudUserCreated = {
    id: string;
    membership: {
        id: string;
        ref: string;
        name: string;
    };
    cloud_user: {
        cloud_id: string;
        email: string;
        name: string;
    };
    access_level: string;
};

export type MembershipCloudUserUpdated = UpdateEvent<Omit<MembershipCloudUserCreated, 'access_level'>>;

export type MembershipCloudUserDeleted = MembershipCloudUserCreated;

export type User = {
    id: string;
    name: string;
    username: string;
    email?: string;
};

export type UserActivated = User;

export type UserDeactivated = User;

export type UserCreated = User;

export type UserUpdated = UpdateEvent<Omit<User, 'email'>>;

export type UserDeleted = User;

export type EntityCreated = {
    id: string;
    type: string;
    name: string;
    identifier: string;
};

export type EntityUpdated = UpdateEvent<EntityCreated>;

export type EntityDeleted = EntityCreated;

type MembershipType = {
    id: string;
    names: Translation[];
};

export type MembershipTypeActivated = MembershipType;

export type MembershipTypeDeactivated = MembershipType;

export type MembershipTypeAllowedTimeCreated = {
    id: string;
    membership_type: MembershipType;
    from_time: string;
    to_time: string;
};

export type MembershipTypeAllowedTimeUpdated = UpdateEvent<
    Omit<MembershipTypeAllowedTimeCreated, 'from_time' | 'to_time'>
>;

export type MembershipTypeAllowedTimeDeleted = Omit<MembershipTypeAllowedTimeCreated, 'from_time' | 'to_time'>;

export type MembershipTypeZoneRuleCreated = {
    id: string;
    membership_type: MembershipType;
    zone: {
        id: string;
        names: Translation[];
    };
};

export type MembershipTypeZoneRuleUpdated = UpdateEvent<MembershipTypeZoneRuleCreated>;

export type MembershipTypeZoneRuleDeleted = MembershipTypeZoneRuleCreated;

export type VisitorAddedToParking = {
    active_stay_id: string;
    active_stay_ref: string;
    entry_time: string;
    gateway: {
        id: string;
        names: Translation[];
    };
    gateway_pass_id: string;
    identifier: {
        type: string;
        value: string;
    };
    membership?: {
        id: string;
        ref: string;
        name: string;
    };
    visitor: {
        id: string;
        main_identifier?: {
            type: string;
            value: string;
        };
    };
    zone: {
        id: string;
        names: Translation[];
    };
};

export type EventData =
    | Login
    | ActiveStayEnded
    | GatewayOpened
    | EmergencyOpenGateway
    | EmergencyCloseGateway
    | MembershipCreated
    | MembershipUpdated
    | MembershipDeleted
    | MembershipIdentifierCreated
    | MembershipIdentifierUpdated
    | MembershipIdentifierDeleted
    | MembershipIdentifierArchived
    | MembershipZoneRuleCreated
    | MembershipZoneRuleUpdated
    | MembershipZoneRuleDeleted
    | MembershipAllowedTimeCreated
    | MembershipAllowedTimeUpdated
    | MembershipAllowedTimeDeleted
    | MembershipCloudUserCreated
    | MembershipCloudUserUpdated
    | MembershipCloudUserDeleted
    | UserActivated
    | UserDeactivated
    | UserCreated
    | UserUpdated
    | UserDeleted
    | EntityCreated
    | EntityUpdated
    | EntityDeleted
    | MembershipTypeActivated
    | MembershipTypeDeactivated
    | MembershipTypeAllowedTimeCreated
    | MembershipTypeAllowedTimeUpdated
    | MembershipTypeAllowedTimeDeleted
    | MembershipTypeZoneRuleCreated
    | MembershipTypeZoneRuleUpdated
    | MembershipTypeZoneRuleDeleted;

export type UserActionEvent = {
    id: string;
    user: {
        id: string;
        name: string;
    };
    cloud_user: {
        id: string;
        name: string;
    };
    created_at: string;
    modified_at: string;
    timestamp: string;
    username: string;
    name: string;
    action_type: UserActionType;
    search_text: string;
    email: string | null;
    event_data: EventData;
};
